import { TenantInspectionHubResponse } from '../../types/inspection'
import { isOverdue } from './inspectionUtils'

export interface SectionExpansionDefaults {
    moveIn: boolean
    property: boolean
    moveOut: boolean
}

export const getSectionExpansionDefaults = (
    hub: TenantInspectionHubResponse,
): SectionExpansionDefaults => {
    const { move_in, property_inspections, move_out } = hub
    const hasUpcoming = property_inspections.upcoming.length > 0
    const hasOverdue = property_inspections.upcoming.some((u) =>
        isOverdue(u.end_date),
    )
    const hasCompleteProperty = property_inspections.complete.length > 0

    if (move_in.state === 'action_required') {
        return { moveIn: true, property: hasUpcoming, moveOut: false }
    }

    if (hasOverdue) {
        return { moveIn: false, property: true, moveOut: false }
    }

    if (move_out.state !== 'not_available') {
        return {
            moveIn: move_in.state === 'complete',
            property: hasUpcoming || hasCompleteProperty,
            moveOut: true,
        }
    }

    if (hasUpcoming) {
        return { moveIn: false, property: true, moveOut: false }
    }

    return {
        moveIn: move_in.state !== 'not_available',
        property: hasCompleteProperty,
        moveOut: false,
    }
}
